const Skeleton = {}

export default Skeleton
